import { map as _map } from 'lodash';
import { ILineObject } from '@lce/intl-types/src/ILineObject';

const removeLine = (array?: ILineObject[]): string[] => _map(array, object => object.line);

export default removeLine;
